import { useState } from 'react'
import * as icons from '../Icons'
import Button from '../Button/Button'

const Icons = (props) => {
  const { className = '' } = props

  const [showHidden, setShowHidden] = useState(true)
  const [illustrations, setIllustrations] = useState(true)

  // Le ciclo due alla volta nascondendo la prima, se qualcosa scompare vanno sistemati gli id
  return (
    <div className={`iconsPreview ${showHidden ? 'iconsPreview--nohidden' : ''} ${className}`}>
      <div className={'iconsPreview__actions'}>
        <Button
          label={illustrations ? 'Vedi tutte' : 'Vedi solo illustrazioni'}
          onClick={() => setIllustrations(!illustrations)}
          variant="ghost"
        />
        <Button
          label={!showHidden ? 'Mostra nascoste' : 'Nascondi ref'}
          onClick={() => setShowHidden(!showHidden)}
          variant="ghost"
        />
      </div>
      <div className={'iconsPreview__list'}>
        {Object.keys(icons)
          .filter((k) => (illustrations ? k.endsWith('Illustration') : true))
          .map((key, index) => {
            const Icon = icons[key]
            return (
              <div className={'iconsPreview__group'} key={index}>
                <div className={'iconsPreview__title'}>{key}</div>
                <div className={'iconsPreview__item'}>
                  <div className={'iconsPreview__hide'}>
                    <Icon idVariant={`${index}_1`} />
                  </div>
                  <div className={'iconsPreview__light'}>
                    <Icon idVariant={`${index}_2`} />
                  </div>
                  <div className={'iconsPreview__dark'}>
                    <Icon idVariant={`${index}_3`} />
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default Icons
